const KEY_CORBIN_PHONE_NUMBER = "VITE_CORBIN_PHONE_NUMBER";
const KEY_GUAC_BASE_URL = "VITE_GUAC_BASE_URL";
const KEY_MIXPANEL_TOKEN = "VITE_MIXPANEL_TOKEN";
const KEY_SENTRY_DSN = "VITE_SENTRY_DSN";
const KEY_SIMBA_PHONE_NUMBER = "VITE_SIMBA_PHONE_NUMBER";
const KEY_SYNCFUSION_LICENSE_KEY = "VITE_SYNCFUSION_LICENSE_KEY";

const getOptionalEnvironmentVariable = (key: string): string | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return import.meta.env[key];
};

const getRequiredEnvironmentVariable = (key: string): string => {
  const val = getOptionalEnvironmentVariable(key);
  if (!val) {
    throw new Error(`Environment variable ${key} must be defined!`);
  }

  return val;
};

export const env = {
  getCorbinPhoneNumber: () => {
    return getRequiredEnvironmentVariable(KEY_CORBIN_PHONE_NUMBER);
  },
  getGuacBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_GUAC_BASE_URL);
  },
  getMixpanelToken: () => {
    return getRequiredEnvironmentVariable(KEY_MIXPANEL_TOKEN);
  },
  getSentryDsn: () => {
    return getRequiredEnvironmentVariable(KEY_SENTRY_DSN);
  },
  getSimbaPhoneNumber: () => {
    return getRequiredEnvironmentVariable(KEY_SIMBA_PHONE_NUMBER);
  },
  getSyncfusionKey: () => {
    return getRequiredEnvironmentVariable(KEY_SYNCFUSION_LICENSE_KEY);
  },
  /**
   * Returns `true` if the environment is production. This
   * is a special built-in constant that is set by Vite.
   *
   * https://vite.dev/guide/env-and-mode#built-in-constants
   */
  getIsProduction: () => {
    return import.meta.env.PROD;
  },
};
